class focusPoint3 {
  constructor () {
    this.oTarget = $('.lh-f-p-3')
    this.oSlick = $('.lh-f-p-3-slick')
    this.aItemInfo = []
    this.oProcessNumBox = $('.js-process-num-box')
    this.oLineHover = $('.line-hover')
    this.oInfoBox = $('.js-f-p-3-info-box')
    this.pageIndex = $('#page-5').length === 0 ? 5 : 6
    this.pageIndexName = $('#page-5').length === 0 ? '#fifth' : '#sixth'
    
    
    //  移动端兼容布局 author Buff modify 6:47 PM 3/28/2018
    this.mobileHack()
    
    //  bug 移动端因fullpage滚动导致的分享失效问题
    this.fixShare()
    
    //  监听移入事件
    $(window).on('G2_onLeave', ev => {
      if (ev.nextIndex == this.pageIndex && !window.__focusPoint3) {
        this.init()
      }
      if (ev.nextIndex == this.pageIndex) {
        let oCurrent = $('.slick-current')
        oCurrent.removeClass('slick-current')
        setTimeout(() => {
          oCurrent.addClass('slick-current')
        }, 400)
      }
    })
    
    //  加载进入
    if (window.hash == this.pageIndexName) {
      if (!window.__focusPoint3) {
        if (window.__fullPageInitEd) {  //  判断fullpage是否已经初始化了
          this.init()
        } else {
          $(window).on('G2_afterRender', ev => this.init())
        }
      }
    }
    
    if (window.preloadType == 'history') {
      this.init(true)
    }
    
    //  延迟加载
    window.setTimeout(() => {
      !window.__focusPoint3 && this.init()
    }, window.gp_load_all)
  }
  
  init (isPreload) {
    window.__focusPoint3 = true
    //  初始化html 代码
    this.initHTML()
    
    //  初始化process bar
    this.initProcessBar()
    
    //  初始化slick
    this.callSlick()
    
    //  处理分享页面
    if (isPreload) {
      $.fn.fullpage.moveTo(this.pageIndex)
    }
    
    let num = window.preloadNum && parseInt(window.preloadNum) <= this.aItemInfo.length ? window.preloadNum : 1
    num -= 1
    //  初始化第一个
    
    this.oSlick.slick('slickGoTo', num)
    this._changeProcessWithInfo(num)
    
    
    window.setTimeout(() => {
      this.oSlick.slick('setPosition')
    }, 500)
    
    //  监听process Bar
    $(window).resize(() => {
      let oCurrent = $('.js-process-num-box').children('active')
      if (oCurrent.length > 0) {
        this._setHoveLinePosition(oCurrent.index())
      }
    }).trigger('resize')
    
    
    //  处理desc移动与PC的描述切换
    $(window).resize(() => {
      let oDesc = this.oInfoBox.find('.desc')
      let desc = ''
      try {
        desc = window.innerWidth < window.gp_max_md ? this.aItemInfo[window.__focusPoint3CurrentSlick].desc : this.aItemInfo[window.__focusPoint3CurrentSlick].desc
      } catch (e) {
      
      }
      oDesc.html(desc.desc)
    }).trigger('resize')
    
    window.loadingBar.animate(1)
    
    
    //  执行动画
    $(window).on('G2_afterLoad', ev => {
      if (ev.index == this.pageIndex) {
        //  移動動畫
        if (window.innerWidth < window.gp_max_md) {
          $('.lh-f-p-3')
          .find('.lh-f-p-3-title,.lh-f-p-3-slick,.lh-f-p-3-animate,.share-box')
          .velocity('transition.slideUpBigIn', {
            stagger: 80
          })
          $('.js-process-num-box-mobile').velocity('transition.slideUpBigIn', {
            display: 'flex',
            delay: 400
          })
        } else {  //  PC动画
          $('.lh-f-p-3')
          .find('.focus-point-title,.lh-f-p-3-animate,.share-box')
          .velocity('transition.slideUpBigIn', {
            stagger: 80
          })
        }
      } else {
        if (window.innerWidth < window.gp_max_md) { //  移动动画
          $('.lh-f-p-3')
          .find('.lh-f-p-3-title,.lh-f-p-3-slick,.lh-f-p-3-animate,.share-box,.js-process-num-box-mobile')
          .css('opacity', 0)
        } else {  //  PC动画
          $('.lh-f-p-3')
          .find('.focus-point-title,.lh-f-p-3-animate,.share-box')
          .css('opacity', 0)
        }
        
      }
    })
    
  }
  
  fixShare () {
    window.setTimeout(() => {
      $('#lh-f-p-3-share').find('a').map(function () {
        $(this).attr('href', 'javascript:;')
      })
    }, 3000)
    
    //  关掉事件
    $(document.body).on('click', '#lh-f-p-3-share a', ev => {
      ev.preventDefault()
      
      ev.stopImmediatePropagation()
      
      let target = ev.currentTarget
      
      let shareTarget = this.oInfoBox.find('#lh-f-p-3-share').get(0)
      
      //  https://www.addtoany.com/add_to/twitter?linkurl=https%3A%2F%2Flocalhost%3A3000%2F%3Ftype%3Dpicture%26num%3D1&amp;linkname=%E7%B2%BE%E5%BD%A9%E5%9B%BE%E9%9B%86&amp;linknote=
      let link = `https://www.addtoany.com/add_to/${target.className.replace('a2a_button_', '')}?linkurl=${encodeURIComponent(shareTarget.dataset.a2aUrl)}&linkname=${encodeURIComponent(shareTarget.dataset.a2aTitle)}&linknote=`
      
      window.open(link, '_blank')
      
      return false
    })
  }
  
  mobileHack () {
    $('.js-process-num-box-mobile').addClass('hidden-lg')
    $('.js-process-num-box,.lh-line').addClass('visible-lg-flex')
    let style = $('<style id="focusPoint3Style"></style>')
    $('head').append(style)
    $(window).resize(() => {
      let slickHeight = window.innerWidth * 9 / 16
      let height = window.innerHeight - slickHeight - (19 + 16 + 22) - 80 - 50
      style.html(`
        @media(max-width:${window.gp_max_md - 1}px){
        .f-p-3-info-box{
          height:${height}px !important;
        }
        }
      `)
    }).trigger('resize')
  }
  
  /**
   * 处理processBar
   */
  initProcessBar () {
    //  处理hover active
    $('.lh-f-p-3-process-item-box button').hover(ev => {
      window.innerWidth > window.gp_max_md && $(ev.currentTarget).parent().addClass('hover')
    }, ev => {
      $(ev.currentTarget).parent().removeClass('hover')
    })
    
    $('.lh-f-p-3-process-item-box button').on('click', ev => this.oSlick.slick('slickGoTo', ev.currentTarget.dataset.index))
    
  }
  
  callSlick () {
    this.oSlick.on('beforeChange', (event, slick, current, nextSlide) => {
      //  修改processBar
      this._changeProcessWithInfo(nextSlide)
    })
    
    let prev = window.gp2_is_rtl ? 'slick-next' : 'slick-prev'
    let next = window.gp2_is_rtl ? 'slick-prev' : 'slick-next'
    this.oSlick.slick({
      slidesToShow: 1,
      infinite: false,
      slidesToScroll: 1,
      arrows: true,
      cssEase: 'ease-in-out',
      speed: 450,
      appendDots: '.js-process-num-box-mobile',
      dots: true,
      prevArrow: `<button class="${prev} visible-lg"><img src="${window.gp2_basic_image_path}/focus-point/arrow_left.svg"></button>`,
      nextArrow: `<button class="${next} visible-lg"><img src="${window.gp2_basic_image_path}/focus-point/arrow_right.svg"></button>`,
      swipe: false,
      rtl: window.gp2_is_rtl,
      responsive: [
        {
          breakpoint: window.gp_max_md,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            infinite: true,
            variableWidth: true,
            swipe: true,
            centerPadding: '20px'
          }
        }
      ]
    })
  }
  
  /**
   * 初始化html 代码
   */
  initHTML () {
    let btnHoverImg = this.oProcessNumBox.get(0).dataset.hoverButtonImg;
    let imageBasicLink = $('.lh-f-p-3-slick').get(0).dataset.titleImgPath
    //  初始化slick item + process num 代码
    this.oSlick.children().map((k, el) => {
      //  保存标题
      let desc = el.dataset.desc
      let imgSrc = el.dataset.lazy
      let title = el.dataset.title
      let index = imgSrc.match(/\/(\d+)\.jpg/)[1]
      
      let itemInfo = {
        titleImg: `${imageBasicLink}title/${index}.png`,
        titleMobile: `${imageBasicLink}mobile-title/${index}.png`,
        desc: desc,
        title: title
      }
      this.aItemInfo.push(itemInfo)
      
      let imgLink = el.dataset.lazy
      el.src = imgLink
      
      $(el).wrap(`<div data-index="${k}" class="lh-f-p-3-item" />`)
      
      //  添加Process num
      this.oProcessNumBox.append(`<div data-index="${k}" class="lh-f-p-3-process-item-box">
                                    <button data-index="${k}"><span>${k + 1}</span><img src="${btnHoverImg}" class="lh-f-p-3-btn-hover-icon"></button>
                                  </div>`)
    })
    
    //  加载默认图片
    this.aItemInfo.map(item => {
      //  默认加载下图片
      let _oImg = new Image()
      let _o2Img = new Image()
      _oImg.src = item.titleImg
      _o2Img.src = item.titleMobile
    })
    
  }
  
  /**
   * 修改process item 里面的item 和 info box 里面的信息
   * @param index
   * @private
   */
  _changeProcessWithInfo (index) {
    if (index == -1) {
      index = window.__focusPoint3CurrentSlick
    }
    //  修改process bar
    let btnDiv = this.oProcessNumBox.children().eq(index)
    btnDiv.addClass('active').siblings().removeClass('active')
    window.innerWidth > window.gp_max_md && this._setHoveLinePosition(index)
    
    if (window.innerWidth < window.gp_max_md) {
      let offset = (window.innerWidth / 2) - (btnDiv.outerWidth() / 2)
      btnDiv.velocity('scroll', {
        axis: 'x',
        container: this.oProcessNumBox,
        offset: offset * -1,
        complete: () => {
          window.innerWidth < window.gp_max_md && this._setHoveLinePosition(index)
        }
      })
    }
    
    //  修改info box
    let oTitle = this.oInfoBox.find('.title')
    let oDesc = this.oInfoBox.find('.desc')
    
    if (window.innerWidth < window.gp_max_md) {
      this.oInfoBox.find('.lh-f-p-3-animate').show()
      
      let titleImg = ''
      let titleMobile = ''
      let desc = ''
      
      try {
        titleImg = this.aItemInfo[index].titleImg
        titleMobile = this.aItemInfo[index].titleMobile
        desc = this.aItemInfo[index].desc
      } catch (e) {
      
      }
      
      if (window.gp2_is_latin) {
        oTitle.html(this.aItemInfo[index].title)
        this._latinFixShadowTitle(this.aItemInfo[index].title)
      } else {
        oTitle.html($(`
                    <img src="${titleImg}" class="visible-lg"/>
                    <img src="${titleMobile}" class="hidden-lg"/>
        `))
      }
      oDesc.html(desc)
    } else {
      this.oInfoBox.find('.lh-f-p-3-animate').velocity('finish').velocity('transition.slideDownOut', {
        duration: 450,
        complete: () => {
          // oTitle.html(this.aItemInfo[index].title)
          if (window.gp2_is_latin) {
            oTitle.html(this.aItemInfo[index].title)
            this._latinFixShadowTitle(this.aItemInfo[index].title)
          } else {
            oTitle.html($(`<img src="${this.aItemInfo[index].titleImg}" />`))
          }
          oDesc.html(this.aItemInfo[index].desc)
          this.oInfoBox.find('.lh-f-p-3-animate').show().css('opacity', 0)
          this.oInfoBox.find('.lh-f-p-3-animate').velocity('finish').velocity('transition.slideUpIn', {
            stagger: 180
          })
        }
      })
    }
    
    
    let shareTarget = this.oInfoBox.find('#lh-f-p-3-share').get(0)
    let myIndex = index + 1
    myIndex = myIndex == 0 ? 1 : myIndex
    let host = `https://${window.location.host}${window.location.pathname}`
    shareTarget.dataset.a2aUrl = `${host}?type=history&num=${myIndex}`
    shareTarget.dataset.a2aTitle = document.title
    
    
    try {
      $.fn.fullpage.reBuild()
    } catch (err) {
      
    }
    
    window.__focusPoint3CurrentSlick = index
  }
  
  /**
   * 修复外文的 title没法加阴影的问题 (中文使用的是图片)
   * @param title
   * @private
   */
  _latinFixShadowTitle (title) {
    if ($('head').find('#f-p-3-shadow-fix-title').length == 0) {
      $('head').append(`<style id="f-p-3-shadow-fix-title"></style>`)
    }
    
    $('#f-p-3-shadow-fix-title').html(`
      #lh-f-p-3 .f-p-3-info-box .title::after{
        content: "${title}";
      }
    `)
  }
  
  
  /**
   * 设置process Bar 的hover Line 位置
   * @param index
   * @private
   */
  _setHoveLinePosition (index) {
    let left = this.oProcessNumBox.children().eq(index).find('button').position().left
    this.oLineHover.velocity({
      left: left + 32 + 18  //  32 是父级div的margin , 18 是button的内边距
    }, {
      duration: 300
    })
  }
  
}

export default focusPoint3